import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Golden Retriever Mom',
    text: "I made the Golden Retriever pattern for my sister's birthday. When she saw it, she cried. I never thought a pattern could generate that."
  }, {
    name: 'Sofía R.',
    role: 'Crochet Entrepreneur',
    text: 'My clients went crazy when I started offering custom pets. This ebook paid for itself with the first order.'
  }, {
    name: 'Elena V.',
    role: 'Cat Lover',
    text: 'The instructions are very clear. I have been making amigurumis for years but I had never found such detailed patterns with the real features of the breed.'
  }];
  return <section id="testimonios" className="py-10 md:py-16 bg-linen" data-id="element-380">
      <div className="max-w-5xl mx-auto px-4" data-id="element-381">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-382">
          <p className="text-sm font-bold tracking-[0.2em] text-copper uppercase mb-4" data-id="element-383">
            What people who already crocheted say
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-384">
            Amigurumis that truly touch your heart
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-385">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="etsy-card p-7" data-id="element-386">
              <div className="flex gap-0.5 mb-4" data-id="element-387">
                {[...Array(5)].map((_, j) => <Star key={j} size={15} className="text-amber-400 fill-amber-400" data-id="element-388" />)}
              </div>
              <p className="text-gray-600 italic mb-6 leading-relaxed text-sm" data-id="element-389">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 border-t border-gray-50 pt-4" data-id="element-390">
                <div className="w-9 h-9 rounded-full bg-cream flex items-center justify-center font-bold text-copper text-xs" data-id="element-391">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-392">
                  <h4 className="font-bold text-deep-brown text-sm" data-id="element-393">
                    {t.name}
                  </h4>
                  <p className="text-xs text-gray-400" data-id="element-394">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}